import ApiClient from './ApiClient';

class ProjectContacts extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
    this.projectId = null;
  }

  get url() {
    return `${this.baseUrl()}/projects/${this.projectId}/contacts`;
  }

  get(projectId) {
    this.projectId = projectId;
    return super.get();
  }

  create(projectId, { contactId, roles }) {
    this.projectId = projectId;
    return super.create({ project_contact: { contact_id: contactId, roles } });
  }

  update(projectId, id, { roles }) {
    this.projectId = projectId;
    return super.update(id, { project_contact: { roles } });
  }

  delete(projectId, id) {
    this.projectId = projectId;
    return super.delete(id);
  }
}

export default new ProjectContacts();
